import { useState, useEffect } from 'react'

export const useErrorMessage = (error) => {
  const [message, setMessage] = useState<string>()
  useEffect(() => error && setMessage(error.message.replace('GraphQL error: ', '')), [error])

  return [message, setMessage]
}

export default useErrorMessage